import {createAction} from '@ngrx/store';

export const tryLoadInitialConfig = createAction(
  '[Global] Initiate Load initial config',
);

export const loadInitialConfig = createAction(
  '[Global] Actually Load initial config',
);

export const initialConfigLoaded = createAction(
  '[Global] Initial config loaded'
);


